var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4345 22.082L17.4707 16.1182C19.0199 14.2235 19.7815 11.8059 19.5982 9.36537C19.4148 6.92487 18.3004 4.6482 16.4855 3.00628C14.6707 1.36437 12.2941 0.482826 9.8475 0.543999C7.40088 0.605172 5.07136 1.60438 3.3408 3.33494C1.61024 5.06551 0.611032 7.39502 0.549858 9.84164C0.488685 12.2883 1.37023 14.6648 3.01214 16.4797C4.65406 18.2946 6.93073 19.4089 9.37123 19.5923C11.8117 19.7757 14.2294 19.014 16.124 17.4648L22.0879 23.4287L23.4345 22.082ZM10.1012 17.7144C8.59427 17.7144 7.1212 17.2675 5.86826 16.4303C4.61531 15.5931 3.63876 14.4032 3.06209 13.011C2.48542 11.6188 2.33454 10.0869 2.62852 8.60891C2.9225 7.13096 3.64815 5.77338 4.71369 4.70783C5.77923 3.64229 7.13682 2.91664 8.61477 2.62266C10.0927 2.32868 11.6247 2.47956 13.0169 3.05623C14.4091 3.6329 15.599 4.60945 16.4362 5.8624C17.2734 7.11534 17.7202 8.58841 17.7202 10.0953C17.718 12.1153 16.9145 14.0519 15.4862 15.4803C14.0578 16.9087 12.1212 17.7121 10.1012 17.7144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5499567b53d35ef95ded163a0f544580.svg";
export { ForwardRef as ReactComponent };